import { apiClient } from './client';

export interface LookupRecord {
  id: number;
  isActive: boolean;
  [key: string]: unknown;
}

export const listLookup = async (
  basePath: string,
  params?: Record<string, unknown>,
): Promise<LookupRecord[]> => {
  const { data } = await apiClient.get(basePath, { params });
  return data.data;
};

export const createLookup = async (
  basePath: string,
  payload: Record<string, unknown>,
): Promise<LookupRecord> => {
  const { data } = await apiClient.post(basePath, payload);
  return data.data;
};

export const updateLookup = async (
  basePath: string,
  id: number,
  payload: Record<string, unknown>,
): Promise<LookupRecord> => {
  const { data } = await apiClient.patch(`${basePath}/${id}`, payload);
  return data.data;
};
